import { Pipe, PipeTransform } from '@angular/core';


/**
 * @see https://en.wikipedia.org/wiki/Inch
 */
export enum LengthConversion {
  MM_INCH = 'MM-INCH',
  INCH_MM = 'INCH-MM'
}

@Pipe({
  name: 'convertLength',
  pure: true
})
export class MmuLengthPipe implements PipeTransform {

  transform(value: number, conversion: LengthConversion): number {
    switch (conversion) {
      case LengthConversion.MM_INCH:
        return (value / 25.4);
      case LengthConversion.INCH_MM:
        return (value * 25.4);
    }
  }
}
